import React from 'react'

const Row = props => (
    <div className={ `${props.className || ''} row`}>
        { props.children }
    </div>
)

export default Row